// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formVideoFile[data-v-49a06c5e]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important;cursor:pointer;position:absolute;width:100%;top:-10px;left:0;font-size:0!important;min-height:60px;border-radius:0!important;border:none!important;white-space:nowrap!important;overflow:hidden!important;padding:0!important;background:none!important}.imageBorder[data-v-49a06c5e]{box-shadow:0 0 2px 0 #bfbfda}", ""]);
// Exports
module.exports = exports;
